import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { useTilt } from '../../hooks/use-tilt';
import { Layout, Smartphone, Mail, MapPin, RefreshCw, Zap, Sparkles, MonitorSmartphone, Target, Search } from 'lucide-react';

const iconMap = {
  layout: Layout,
  smartphone: Smartphone,
  mail: Mail,
  'map-pin': MapPin,
  'refresh-cw': RefreshCw,
  zap: Zap,
  sparkles: Sparkles,
  'monitor-smartphone': MonitorSmartphone,
  target: Target,
  search: Search
};

const ServiceCard = ({ service }) => {
  const tiltRef = useTilt({ max: 10, scale: 1.05, speed: 500 });
  const Icon = iconMap[service.icon];
  
  return (
    <div ref={tiltRef} className="group">
      <Card 
        className="bg-gradient-to-br from-gray-900/70 via-gray-900/60 to-gray-900/50 border border-white/15 hover:border-[#2F6BFF]/50 hover:shadow-lg hover:shadow-[#2F6BFF]/10 transition-all duration-500 h-full shadow-3d-hover"
        style={{ 
          transformStyle: 'preserve-3d',
          boxShadow: '0 8px 24px rgba(0,0,0,0.4), 0 16px 48px rgba(0,0,0,0.2), inset 0 0 40px rgba(34,211,238,0.02)'
        }}
      >
        <CardHeader style={{ transformStyle: 'preserve-3d', transform: 'translateZ(40px)' }}>
          <div 
            className="w-16 h-16 rounded-xl bg-gradient-to-br from-#2F6BFF/20 to-#4DA3FF/5 flex items-center justify-center mb-4 group-hover:from-#2F6BFF/30 group-hover:to-#4DA3FF/10 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
            style={{ 
              boxShadow: '0 4px 12px rgba(47, 107, 255, 0.1)',
              transform: 'translateZ(20px)'
            }}
          >
            <Icon className="h-8 w-8 text-[#2F6BFF] group-hover:scale-110 transition-transform duration-500" />
          </div>
          <CardTitle className="text-xl text-[#F5F7FF] mb-3 group-hover:text-[#2F6BFF] transition-colors duration-300">
            {service.title}
          </CardTitle>
          <CardDescription className="text-[#9AA3B2] leading-relaxed group-hover:text-[#F5F7FF] transition-colors duration-300">
            {service.description}
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
};

export default ServiceCard;
